import React from 'react';

interface Props {
  className?: string;
}

const Fence: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="7"
    viewBox="0 0 24 7"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Fence">
      <path d="M0 1.5L24 1.5" id="Vector 30" stroke="currentColor" />
      <path d="M0 5.5L24 5.5" id="Vector 31" stroke="currentColor" />
      <line
        id="Line 80"
        stroke="currentColor"
        x1="2.09998"
        x2="2.09998"
        y1="0.5"
        y2="6.5"
      />
      <line
        id="Line 81"
        stroke="currentColor"
        x1="5.29999"
        x2="5.29999"
        y1="0.5"
        y2="6.5"
      />
      <line
        id="Line 82"
        stroke="currentColor"
        x1="8.5"
        x2="8.5"
        y1="0.5"
        y2="6.5"
      />
      <line
        id="Line 83"
        stroke="currentColor"
        x1="14.9"
        x2="14.9"
        y1="0.5"
        y2="6.5"
      />
      <line
        id="Line 84"
        stroke="currentColor"
        x1="18.1"
        x2="18.1"
        y1="0.5"
        y2="6.5"
      />
      <line
        id="Line 85"
        stroke="currentColor"
        x1="21.3"
        x2="21.3"
        y1="0.5"
        y2="6.5"
      />
      <line
        id="Line 87"
        stroke="currentColor"
        x1="11.7"
        x2="11.7"
        y1="0.5"
        y2="6.5"
      />
    </g>
  </svg>
);

export default Fence;
